import { render, staticRenderFns } from "./EditAdvertisement.vue?vue&type=template&id=0422578a&"
import script from "./EditAdvertisement.vue?vue&type=script&lang=js&"
export * from "./EditAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvertisement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports